<div id="message">
  <h2>No Access</h2>
  <h1>權限尚未開放，請聯繫管理員!</h1>
  <button (click)="logout()">重新登入</button>
</div>
